import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ngx-modal-quiero-ser-socio',
  templateUrl: './modal-quiero-ser-socio.component.html',
  styleUrls: ['./modal-quiero-ser-socio.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService]
})



export class ModalQuieroSerSocioComponent implements OnInit {
  private valorSelect: number;
  constructor(private router:Router,public fb: FormBuilder, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalQuieroSerSocioComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService) { 
      this.ListadoFormasPago = {FormasPago:[]};
      this.ListadoTipoSocio = {TipoSocio:[]};
     // this.ListadoFormasPago.FormasPago.push({_forma_pago_id:0,_nombre:"Seleccione forma de pago"});
     // this.ListadoTipoSocio.TipoSocio.push({_tipo_socio_id:0,_nombre:"Seleccione un tipo de socio"});
      this.nuevaEntidad = {Nombre:"",Apellidos:"",Email:"",EmpresaInstitucion: this.EsEmpresaInstitucion, EsSocio: this.EsSocio};
     
  }

  TipologiasSelect: any;
  tokenRequest: any;
  nuevaEntidad: any;
  DeshabilitaBoton: Boolean = true;
  EsEmpresaInstitucion: Number = 0;
  EsSocio: Number = 0;
  nombreFisica :any = null;
  apellidosFisica:any = null;
  emailFisica:any = null;
  nombreEmpresa:any = null;
  dni:any = null;
  emailEmpresa:any = null;
  ListadoFormasPago:any;
  ListadoTipoSocio:any;
  IBAN:any;
  EntidadBancaria:any;
  resultPagoEntidades:any;
  IBANN:any;
  entiBancaria:any;
  FormPagoId:any;
  avisoPagoEnt:boolean = false;
  TipoSocio:any;
  resultAddSocio:any;
  Objeto:any;
  resultAddAll:any;
  avisoDomicializacion:Boolean = false;
  mostrarRequisitos:Boolean = false;
  descripcionRequisitos:any = "";
  precioTipoSocio:any = "";
  selectedOption:any = 1;
  count:any = 0;

  TipoEmpresaInstitucion = [
    { value: '0', label: 'Soy una persona física'},
    { value: '1', label: 'Soy una empresa o una institución'},
  ];


  TipoSocioNoSocio = [
    { value: '0', label: 'No socio'},
    { value: '1', label: 'Socio'},
  ];


  ngOnInit() {
    this.FormPagoId = '1';
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.tokenRequest = token;
      }
    }); 
    this._PeticionesHttpBackEndService.getAllReg("v1/FormasPago").subscribe(
      result => {
        let resultadoFormasPago: any;
        resultadoFormasPago = result;
        for (let formaPago of resultadoFormasPago.FormasPago){
          this.ListadoFormasPago.FormasPago.push({_forma_pago_id:formaPago._forma_pago_id,_nombre:formaPago._nombre});
        }
      },
      error => {

      }
    );
    
    this._PeticionesHttpBackEndService.getAllReg("v1/TipoSocio/"+this.data.entidadId).subscribe(
      result => {
        let resultadoTipoSocio: any;
        resultadoTipoSocio = result;
        this.count = 0;
        for (let tipoSocio of resultadoTipoSocio.TipoSocio){
          if(this.count == 0){
            this.mostrarRequisitos = true;
            this.descripcionRequisitos = tipoSocio._requisitos;
            this.precioTipoSocio = tipoSocio._precio;
            this.TipoSocio = tipoSocio._tipo_socio_id;
          }
          this.ListadoTipoSocio.TipoSocio.push({_tipo_socio_id:tipoSocio._tipo_socio_id,_nombre:tipoSocio._nombre,_precio:tipoSocio._precio,_requisitos:tipoSocio._requisitos});
          this.count = this.count + 1;
        }
      },
      error => {

      }
    );
    this._PeticionesHttpBackEndService.getAllReg("v1/PagosEntidades/"+this.data.entidadId+"").subscribe(
      result => {
        this.resultPagoEntidades = result;
        if(this.resultPagoEntidades.Code == 200){
          this.IBANN = this.resultPagoEntidades.FormasPago._i_b_a_n;
          this.entiBancaria = this.resultPagoEntidades.FormasPago._entidad_bancaria;
          this.FormPagoId = this.resultPagoEntidades.FormasPago._forma_pago_id;
          this.avisoPagoEnt = true;
          this.isIbanValid = true;
        }
      },
      error => {

      }
    );
  }




  setObjetonuevaEntidad(event){
    let resultado;
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      switch(event.target.name){
        case "_nombre": this.nuevaEntidad.Nombre = event.target.value; break;
        case "_apellidos": this.nuevaEntidad.Apellidos = event.target.value; break;
        case "_email": 
        this._PeticionesHttpBackEndService.postRequest("CheckEmailExist",{Data:{Email:event.target.value}}).subscribe(
          result => {
            resultado = result;
            if (resultado.Exist == true){
              this.utilidades.notificationWarning("Error","Este email ya existe en la base de datos, cada email debe ser único.","top-left");
              this.DeshabilitaBoton = true;
            }else{
              this.DeshabilitaBoton = false;
              this.nuevaEntidad.Email = event.target.value; 
            }
          },
          error => {

          }
        );

        break;
      }
    }

  }
  ibanValid:any;
  isIbanValid:boolean = false;
  ibanREG = /^ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}/;
  validIBAN(){
  
      this.ibanValid= !this.IBANN.match(this.ibanREG) ? "border-dangerC" : "";
  
      this.isIbanValid = !this.IBANN.match(this.ibanREG) ? false : true;
      
  }
  save(){
    if(!this.isIbanValid && !this.avisoDomicializacion){
      this.utilidades.notificationWarning("Aviso","Revise los datos de domicialización","top-left");
    }else{
        

         this.Objeto = {EntidadId:this.data.entidadId, TipoSocioId:this.TipoSocio, IBAN:this.IBANN, 
            EntidadBancaria:this.entiBancaria, FormaPago: this.FormPagoId,AvisoDomicializacion:this.avisoDomicializacion,AvisoPagoEnt:this.avisoPagoEnt};
      this._PeticionesHttpBackEndService.postRequest("v1/addSocioAll",{Data:this.Objeto}).subscribe(
        result => {
          this.resultAddAll = result;
          if(this.resultAddAll.Code == 200){
            this.utilidades.notificationSuccess("Exito",this.resultAddAll.Mensaje,"top-left");
          }else{
            this.utilidades.notificationWarning("Aviso",this.resultAddAll.Mensaje,"top-left");
          }
        }
      );  
      this.dialogRef.close();
    }


   /* if(this.avisoPagoEnt && (this.TipoSocio == undefined || this.TipoSocio == 0)){
      this.utilidades.notificationWarning("Aviso","Seleccione un tipo de socio.","top-left");
    }else if(this.avisoPagoEnt && (this.TipoSocio != undefined || this.TipoSocio != 0)){
      this._PeticionesHttpBackEndService.getAllReg("v1/addSocioTipo/"+this.data.entidadId+"/"+this.TipoSocio).subscribe(
        result => {
          this.resultAddSocio = result;
        },
        error => {
  
        }
      );
      this.dialogRef.close();
    }else if(!this.avisoPagoEnt && (this.TipoSocio == undefined || this.IBANN == undefined || this.entiBancaria == undefined || this.TipoSocio == 0 || this.FormPagoId == 0)){
      this.utilidades.notificationWarning("Aviso","Rellene todos los campos.","top-left");
    }else{
      this.Objeto = {EntidadId:this.data.entidadId, TipoSocioId:this.TipoSocio, IBAN:this.IBANN, EntidadBancaria:this.entiBancaria, FormaPago: this.FormPagoId};
      this._PeticionesHttpBackEndService.postRequest("v1/addSocioAll",{Data:this.Objeto}).subscribe(
        result => {
          this.resultAddAll = result;
          if(this.resultAddAll.Code == 200){
            this.utilidades.notificationSuccess("Exito",this.resultAddAll.Mensaje,"top-left");
            this._PeticionesHttpBackEndService.getAllReg("v1/addSocioTipo/"+this.data.entidadId+"/"+this.TipoSocio).subscribe(
              result => {
                this.resultAddSocio = result;
              },
              error => {
        
              }
            );
          }else{
            this.utilidades.notificationWarning("Aviso",this.resultAddAll.Mensaje,"top-left");
          }
        }
      );    
      this.dialogRef.close();
    }*/
  }

  close(){
    this.dialogRef.close();
  }

  setDatoObjetoEntidad(event){
    //if(event.target.name == "FormaPagoId"){
      this.FormPagoId = event.target.value;
      if(this.FormPagoId == 1){
        this.avisoDomicializacion = false;
      }else{
        this.avisoDomicializacion = true;
      }
    /*}else{
      this.TipoSocio = event.target.value;
    }*/
    
  }
  changeTipoSocio(event){
    this.mostrarRequisitos = true;
    this.descripcionRequisitos = event._requisitos;
    this.precioTipoSocio = event._precio;
    this.TipoSocio = event._tipo_socio_id;
  }

}
